import styled from 'styled-components';
import { ThemeColours } from '../../../../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../../../common/styles/constants';
import { propSwitch } from '../../../../../common/util/propSwitch';
import RadioChecked from './RadioChecked.svg';
import RadioCheckedFullFill from './RadioCheckedFullFill.svg';
import RadioUnchecked from './RadioUnchecked.svg';

export const RadioUncheckedTeal = styled(RadioUnchecked)`
  color: ${ThemeColours.mono300};
  fill: currentColor;
  height: 24px;
  @include transition(all 0.2s ease);
  width: 24px;
`;

export const RadioLabel = styled.label<{ selected: boolean }>`
  color: ${ThemeColours.mono700};
  ${FONT_STACK};
  cursor: pointer;
  font-weight: ${propSwitch('selected', FontWeight.SEMI_BOLD, FontWeight.REGULAR)};
  @include transition(all 0.2s ease);
`;

export const InputWrapper = styled.div<{ row?: boolean; selected: boolean }>`
  align-items: flex-start;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex: ${propSwitch('row', '1 0 calc(50% - 8px)', '1 0 100%')};
  padding: ${props => props.theme.enumFilter?.optionPadding};

  &:hover {
    cursor: pointer;

    ${RadioLabel}, ${RadioUncheckedTeal} {
      color: ${propSwitch('selected', ThemeColours.mono700, ThemeColours.primary)};
      font-weight: ${FontWeight.SEMI_BOLD};
    }
  }

  &:active {
    background-color: ${ThemeColours.mono200};

    ${RadioUncheckedTeal} {
      color: ${ThemeColours.primary600};
    }
  }

  &:nth-child(odd):not(:last-child) {
    margin-inline-end: ${propSwitch('row', '8px', '0')};
  }
`;

export const NinjaInput = styled.input`
  display: none;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-inline-start: 8px;
`;

export const RadioDescription = styled.span`
  color: ${ThemeColours.mono600};
  font-size: 14px;
  line-height: 16px;
  margin-top: 5px;
`;

export const RadioCheckedTeal = styled(RadioChecked)<{ checked: boolean }>`
  color: ${ThemeColours.primary};
  fill: currentColor;
  height: 24px;
  opacity: ${props => (props.checked ? '1' : '0')};
  @include transition(all 0.2s ease);
  width: 24px;
`;

export const RadioCheckedTealFullFill = styled(RadioCheckedFullFill)<{ checked: boolean }>`
  color: ${ThemeColours.primary};
  fill: currentColor;
  height: 24px;
  opacity: ${props => (props.checked ? '1' : '0')};
  @include transition(all 0.2s ease);
  width: 24px;
`;
